import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { TeacherSearchSelect } from '../TeacherSearchSelect';
import { StudentSearchMulti } from './StudentSearchMulti';
import { CreateTemplateFormData, TeacherInfo, StudentInfo } from './types';

interface StepTeacherStudentProps {
  formData: CreateTemplateFormData;
  updateFormData: (updates: Partial<CreateTemplateFormData>) => void;
}

export function StepTeacherStudent({ formData, updateFormData }: StepTeacherStudentProps) {
  const handleTeacherChange = (code: string, teacher: TeacherInfo | null) => {
    updateFormData({ teacher_code: code, teacher_info: teacher });
  };

  const handleStudentsChange = (students: StudentInfo[]) => {
    updateFormData({ students });
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">เลือกครู</CardTitle>
        </CardHeader>
        <CardContent>
          <Label>ค้นหาครู</Label>
          <div className="mt-2">
            <TeacherSearchSelect
              value={formData.teacher_code}
              onChange={handleTeacherChange}
            />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">เลือกนักเรียน</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>ค้นหานักเรียน (เลือกได้หลายคน)</Label>
            <div className="mt-2">
              <StudentSearchMulti
                selectedStudents={formData.students}
                onChange={handleStudentsChange}
              />
            </div>
          </div>

          {formData.students.length > 0 && (
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted">
                  <tr>
                    <th className="px-4 py-2 text-left">รหัส</th>
                    <th className="px-4 py-2 text-left">ชื่อเล่น</th>
                    <th className="px-4 py-2 text-left">ชื่อ-นามสกุล</th>
                    <th className="px-4 py-2 text-right">ชม.คงเหลือ</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.students.map((student) => (
                    <tr key={student.code} className="border-t">
                      <td className="px-4 py-2">{student.code}</td>
                      <td className="px-4 py-2">{student.nickname || '-'}</td>
                      <td className="px-4 py-2">{student.first_name} {student.last_name}</td>
                      <td className="px-4 py-2 text-right">{student.hours ?? 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
